<template>
  <div class="error-block">
    <v-img
      class="error-block__icon"
      alt="Alert icon"
      :src='images.Alert'/>
    <span class="error-block__title">{{ title }}</span>
  </div>
</template>

<script>
import Alert from '@/assets/icons/alert.png';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    images: {
      Alert,
    },
  }),
};
</script>

<style lang="scss" scoped>

@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.error-block {
  background-color: #fbd3d5;
  padding: 16px;
  display: flex;
  align-items: center;

  &__icon {
    height: 24px;
    max-width: 24px;
    margin-right: 16px;
  }

  &__title {
    font-size: 14px;
    font-weight: 500;
  }
}

</style>
